"use client";

import { useState } from "react";
import SmartCaseFinder from "@/components/smart-finder/SmartCaseFinder";
import CourtLocationTypeahead from "@/components/smart-finder/CourtLocationTypeahead";

interface CaseStatusHubSearchFormProps {
  slug: string;
  surface: string;
  context: string;
  title: string;
  description: string;
}

// Boil the marketing context line down to words that actually steer the
// parser ("High Court case status India" → "High Court"). A leftover bare
// "court" adds nothing to a nationwide search, so drop it entirely.
function usefulCourtContext(value: string) {
  const cleaned = value
    .replace(/\bcase\s+status\b/gi, " ")
    .replace(/\bIndia\b/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return /^courts?$/i.test(cleaned) ? "" : cleaned;
}

export default function CaseStatusHubSearchForm({
  slug,
  surface,
  context,
  title,
  description,
}: CaseStatusHubSearchFormProps) {
  const pageContext = usefulCourtContext(context);
  // The nationwide hub has no court of its own. A picked suggestion becomes
  // the court context for the search, so the server resolves the scope
  // instead of bouncing the visitor with "which court is this case in?".
  const [chosenCourtText, setChosenCourtText] = useState<string | null>(null);
  const courtContext = chosenCourtText || pageContext;

  return (
    <div className="rounded-lg border border-primary-100 bg-white p-4 text-left shadow-lg shadow-primary/5 sm:p-5">
      <div className="mb-2">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        <p className="mt-1 text-sm text-gray-600">{description}</p>
      </div>
      <div className="mb-2">
        <CourtLocationTypeahead onSelect={setChosenCourtText} />
      </div>
      <SmartCaseFinder
        courtContext={courtContext || undefined}
        placeholder="Case number, party name, or CNR"
        searchSlug={slug}
        searchSurface={surface}
      />
    </div>
  );
}
